// service.js
import { useApiHelper } from '../../utils/helper/apiHelper';

export const useActivationService = () => {
    const { post, loading } = useApiHelper();

    const ExecuteProcedure = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    
    // const doActivation = async (payload: any) => {
    //     try {
    //         return await post(`${import.meta.env.VITE_APP_API_URL}/ActivateBot`, payload);
    //     } catch (error) {
    //         console.error('Error fetching dashboard data:', error);
    //         throw error;
    //     }
    // };
    
    return {
        ExecuteProcedure,
     
        loading,
    };
};
